/* eslint-disable react/destructuring-assignment */
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  InputLabel,
  Modal,
  Radio,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { useEffect, useContext } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { AddressEditModalStyles as classes } from './AddressEditModalStyles';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import {
  ADDRESS_EDIT_MODAL_TITLE,
  CONTINUE,
  ADDRESS_EDIT_REASON,
  ADDRESS_EDIT_RADIO_ONE,
  ADDRESS_EDIT_RADIO_TWO,
  EN,
  RADIO_COLOR,
  LIBRE_AHORRA_BUNDLE,
  CLOSE,
} from '../../constants';
import { clearOCRdata, isBundle } from '../commonCode';
import CloseIconIMG from '../../images/Icon.svg';
import { CloseIcon } from '../../images/svg/CustomizedSVG';

const CustomRadio = styled(Radio)(({ theme }) => ({
  color: theme?.palette?.orientalPrimary?.main,
  '&.Mui-checked': {
    color: theme?.palette?.orientalPrimary?.main,
  },
  '&:focus': {
    outline: `2px solid  ${theme?.palette?.orientalPrimary?.main}`,
    outlineOffset: '2px',
  },
}));

function AddressEditModal(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(true);
  const [valid, setValid] = React.useState(false);
  const themes = useTheme();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const {
    setIsScreenThreeDirty,
    setIsScreenFourDirty,
    setIsScreenFiveDirty,
    setIsFundingScreenDirty,
    newAddress,
    setNewAddress,
    addressWithErrors,
    setAddressWithErrors,
    setPopupModalIntial,
    setAddressInformation,
    addressInformation,
    setAddressProofUploadStatus,
    setUserOptionAddress,
    userOptionAddress,
    language,
    productName,
    theme,
  } = leadGenerationContext;
  const { openModal, setIsModal } = props;

  useEffect(() => {
    openModal ? setOpen(true) : setOpen(false);
  }, [openModal]);
  const userOptionAddressChange = () => {
    if (newAddress) {
      if (!userOptionAddress && addressInformation.vouchedAddressVerified) {
        setUserOptionAddress('vouchedNewAddressFlag');
      }
      clearOCRdata(leadGenerationContext);
      setAddressInformation((prevState) => ({ ...prevState, utilityBill: '' }));
    }
    if (addressWithErrors && addressInformation.vouchedAddressVerified) {
      if (!userOptionAddress) {
        setUserOptionAddress('vouchedCurrentAddressFlag');
      }
      if (addressInformation.ocrAddressEdit) {
        setAddressInformation((prevState) => ({
          ...prevState,
          retainUtilityBill: true,
        }));
      }
    }
  };
  const handleContinue = (e) => {
    e.preventDefault();
    if (!newAddress && !addressWithErrors) {
      document.getElementById('borderBox').style.border = '1px solid red';
      document.getElementById('borderBox').style.borderRadius = 'inherit';
      setValid(false);
    } else {
      setValid(true);
    }
    if (valid) {
      userOptionAddressChange();

      setPopupModalIntial(false);
      setIsModal(false);
      setOpen(false);
    }
  };

  const isMobile = useMediaQuery(themes?.breakpoints?.down('1034'), {
    defaultMatches: true,
  });

  const handleRadioOne = (e) => {
    setIsScreenThreeDirty(true);
    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.target.checked === true) {
      document.getElementById('borderBox').style.border = 'none';
      setNewAddress(false);
      setAddressWithErrors(true);
      setValid(true);
    } else {
      setAddressWithErrors(false);
    }
  };
  const handleRadioOneOnEnter = (e) => {
    setIsScreenThreeDirty(true);
    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.key === 'Enter') {
      document.getElementById('borderBox').style.border = 'none';
      setNewAddress(false);
      setAddressWithErrors(true);
      setValid(true);
    }
  };
  const handleRadioTwo = (e) => {
    setIsScreenThreeDirty(true);
    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.target.checked === true) {
      document.getElementById('borderBox').style.border = 'none';
      setNewAddress(true);
      setAddressProofUploadStatus(null);
      setAddressWithErrors(false);

      setValid(true);
    } else {
      setNewAddress(false);
    }
  };
  const handleRadioTwoOnEnter = (e) => {
    setIsScreenThreeDirty(true);
    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsFundingScreenDirty(true);
    if (e.key === 'Enter') {
      document.getElementById('borderBox').style.border = 'none';
      setNewAddress(true);
      setAddressProofUploadStatus(null);
      setAddressWithErrors(false);
      setValid(true);
    }
  };
  const handleClose = () => {
    props.setIsModal(false);
    setOpen(false);
  };
  useEffect(() => {
    if (openModal) setOpen(true);
    else setOpen(false);
  }, [openModal]);

  return (
    <Modal
      sx={classes.backdrop}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(233, 233, 235, 0.78)',
        },
      }}
      open={open}
      role="dialog"
      aria-describedby="dialog1Desc dialog2Desc"
    >
      <Box component="div" sx={classes.productmodal}>
        <Grid container>
          <Card
            sx={{
              ...(isBundle(productName) ? classes.rootBundle : classes.root),
              background: theme?.customBackground,
            }}
          >
            <CardContent sx={classes.card_content} id="borderBox">
              {isBundle(productName) ? (
                <Box component="div" sx={isBundle(productName) ? classes.iconstyle : {}}>
                  <Typography
                    sx={classes.textOneStyleBundle}
                    variant="h3"
                    component="h3"
                    color="primary"
                    marginY="10px"
                    id="dialog1Desc"
                  >
                    {t('Update Your Address', {
                      defaultValue: 'Update Your Address',
                      nsSeparator: '|',
                    })}
                  </Typography>
                  <Typography
                    // sx={language === EN ? classes.reason : classes.reason_es}
                    sx={classes.subtext}
                    id="dialog2Desc"
                    variant="subtitle1"
                    component="p"
                    color="subtext"
                  >
                    {t('Why do you need to change your physical address?', {
                      defaultValue: 'Why do you need to change your physical address?',
                      nsSeparator: '|',
                    })}
                  </Typography>
                </Box>
              ) : (
                <Box component="div">
                  <Typography
                    variant="h3"
                    component="h3"
                    sx={classes.textOneStyle}
                    id="dialog1Desc"
                  >
                    {t(ADDRESS_EDIT_MODAL_TITLE, {
                      defaultValue: ADDRESS_EDIT_MODAL_TITLE,
                      nsSeparator: '|',
                    })}
                  </Typography>
                  <Typography
                    sx={language === EN ? classes.reason : classes.reason_es}
                    id="dialog2Desc"
                  >
                    {t(ADDRESS_EDIT_REASON, {
                      defaultValue: ADDRESS_EDIT_REASON,
                      nsSeparator: '|',
                    })}
                  </Typography>
                </Box>
              )}
              <Box
                component="div"
                // style={{
                //   display: isMobile ? 'inline-grid' : 'inline-flex',
                // }}
                sx={
                  language === EN
                    ? isBundle(productName)
                      ? classes.radioLayoutBundle
                      : classes.radioLayout
                    : isBundle(productName)
                    ? classes.radioLayout_esBundle
                    : classes.radioLayout_es
                }
              >
                <Box
                  component="div"
                  div
                  sx={
                    isBundle(productName)
                      ? [classes.radioLabelCommon, classes.radioLabelBundle]
                      : [classes.radioLabelCommon, classes.radioLabel]
                  }
                >
                  <CustomRadio
                    size="small"
                    sx={{ ...classes.radioRoot, color: theme?.palette?.orientalPrimary?.main }}
                    checked={addressWithErrors}
                    onChange={handleRadioOne}
                    onKeyDown={handleRadioOneOnEnter}
                    value={ADDRESS_EDIT_RADIO_ONE}
                    inputProps={{
                      'data-testid': 'my_address_with_err_testid',
                    }}
                    id={ADDRESS_EDIT_RADIO_ONE}
                    name={ADDRESS_EDIT_RADIO_ONE}
                    aria-label={t(ADDRESS_EDIT_RADIO_ONE)}
                  />
                  {isBundle(productName) ? (
                    <Box sx={classes.radioLabelStyleBundle}>
                      <Typography
                        variant="subtitle1"
                        color="primary"
                        component="p"
                        fontWeight={700}
                      >
                        {t('Correct an error', {
                          defaultValue: 'Correct an error',
                          nsSeparator: '|',
                        })}
                      </Typography>
                      <Typography component="p" variant="subtitle2" style={{ color: '#808285' }}>
                        {t("It's my address, but there are errors.", {
                          defaultValue: "It's my address, but there are errors.",
                          nsSeparator: '|',
                        })}
                      </Typography>
                    </Box>
                  ) : (
                    <InputLabel
                      style={{ marginRight: '16px' }}
                      for="ship the debit card"
                      sx={classes.radioLabelStyle}
                    >
                      {t(ADDRESS_EDIT_RADIO_ONE, {
                        defaultValue: ADDRESS_EDIT_RADIO_ONE,
                        nsSeparator: '|',
                      })}
                    </InputLabel>
                  )}
                </Box>
                <div
                  style={{
                    marginBottom: isMobile ? '10px' : '0px',
                    display: 'flex',
                    alignItems: isBundle(productName) ? 'flex-start' : 'center',
                  }}
                >
                  <CustomRadio
                    size="small"
                    sx={classes.radioRoot}
                    checked={newAddress}
                    onChange={handleRadioTwo}
                    onKeyDown={handleRadioTwoOnEnter}
                    value={ADDRESS_EDIT_RADIO_TWO}
                    inputProps={{
                      'data-testid': 'new_address_testid',
                    }}
                    id={ADDRESS_EDIT_RADIO_TWO}
                    name={ADDRESS_EDIT_RADIO_TWO}
                    aria-label={ADDRESS_EDIT_RADIO_TWO}
                  />
                  {isBundle(productName) ? (
                    <Box sx={classes.radioLabelStyleBundle}>
                      <Typography
                        variant="subtitle1"
                        color="primary"
                        component="p"
                        fontWeight={700}
                      >
                        {t('New address', {
                          defaultValue: 'New address',
                          nsSeparator: '|',
                        })}
                      </Typography>
                      <Typography component="p" variant="subtitle2" style={{ color: '#808285' }}>
                        {t('My address has changed.', {
                          defaultValue: 'My address has changed.',
                          nsSeparator: '|',
                        })}
                      </Typography>
                    </Box>
                  ) : (
                    <InputLabel for={ADDRESS_EDIT_RADIO_TWO} sx={classes.radioLabelStyle}>
                      {t(ADDRESS_EDIT_RADIO_TWO, {
                        defaultValue: ADDRESS_EDIT_RADIO_TWO,
                        nsSeparator: '|',
                      })}
                    </InputLabel>
                  )}
                </div>
              </Box>

              <Box component="div" sx={classes.button}>
                <Button
                  disableFocusRipple
                  autoFocus
                  sx={{
                    ...(isBundle(productName) ? classes.saveAndExitBundle : classes.saveAndExit),
                    color: '#FFFFFF',
                    backgroundColor: theme?.palette?.orientalPrimary?.main,
                    border: `1.6px solid ${theme?.palette?.orientalPrimary?.main}`,
                    ':focus': {
                      outline: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
                      outlineOffset: '2px',
                    },
                    ':hover': {
                      backgroundColor: theme?.palette?.orientalPrimary?.main,
                    },
                  }}
                  data-testid="CloseButtonInProductModal"
                  onClick={handleContinue}
                >
                  {t(CONTINUE, { defaultValue: CONTINUE })}
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </Modal>
  );
}

export default withRouter(AddressEditModal);

AddressEditModal.propTypes = {
  setIsModal: PropTypes.func,
  openModal: PropTypes.bool,
};
